import { NgModule, Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "phoneNumber" })
export class PhoneNumberPipe implements PipeTransform {
    public transform(phoneNumber: string): string {
        const regexSpecialChar = /[ !()*,?-]+/g;
        return phoneNumber.replace(regexSpecialChar, "");
    }
}

@NgModule({
    imports: [PhoneNumberPipe],
    providers: [PhoneNumberPipe],
    exports: [PhoneNumberPipe],
})
export class PhoneNumberPipeModule {}
